import assign from "lodash/fp/assign";
import apis from "../../core/apis.js";

class BusResource {
  constructor($resource, Upload) {
    "ngInject";

    this.Upload = Upload;
    this.$resource = $resource;
  }

  getAll(options) {
    return this.$resource(apis.bus).get(options);
  }

  find(q) {
    return this.$resource(apis.bus + "find").get({ q });
  }

  get(id) {
    return this.$resource(apis.bus + id).get();
  }

  search(query = "", params) {
    return this.$resource(apis.bus + "autocomplete/").get(
      assign(params, { query })
    );
  }

  post(item) {
    return this.$resource(apis.bus).save(item);
  }

  update(id, item) {
    return this.$resource(apis.bus + id, null, {
      update: { method: "PATCH" },
    }).update(item);
  }

  updateAction({ id, name, item, updateMethod }) {
    return updateMethod
      ? this.$resource(`${apis.bus}${id}/${name}`, null, {
          update: { method: updateMethod },
        }).update(item)
      : this.$resource(`${apis.bus}${id}/${name}`).save(item);
  }

  documentUpload(id, data) {
    const url = `${apis.bus}${id}/upload_document`;
    const request = this.Upload.upload({ url, data });
    return { $promise: request };
  }

  documentRemove(id, item) {
    return this.$resource(apis.bus + id + "/remove_document/").save(item);
  }

  generateBusCode(id) {
    return this.$resource(apis.bus + id + "/generate_bus_code").save();
  }
}

export default BusResource;



// WEBPACK FOOTER //
// ./src/resources/bus/bus.resource.js